export default __webpack_public_path__ + "static/media/404_p.f035ebaa.svg";